<template>
  <!-- 首次课历史记录 -->
  <div class="firstClassHistory">
    <header>
      <h3>{{ this.$route.params.name }}{{ text }}</h3>
      <span @click="goBack" class="el-icon-circle-close"></span>
    </header>
    <el-form class="select" label-width="120px">
      <el-form-item label="学生姓名:">
        <el-input placeholder="请输入学生姓名" v-model="studentName" clearable></el-input>
      </el-form-item>
      <el-form-item label="首次课日期:">
        <el-date-picker v-model="classFirstDate" value-format="yyyy-MM-dd" type="date" placeholder="选择首次课日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="上课时间:">
        <el-time-picker value-format="HH:mm" format="HH:mm" is-range v-model="classDate" range-separator="至"
          start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
        </el-time-picker>
        <!-- <el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="选择上课时间">
        </el-date-picker> -->
      </el-form-item>
      <el-form-item label="首次课成功情况:">
        <el-select v-model="success" placeholder="请选择首次课成功情况">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="clean">清除</el-button>
        <el-button type="primary" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-table :header-cell-style="{
      background: '#fafafa',
    }" :data="dataList" border>
      <el-table-column prop="studentName" :resizable="false" label="学生姓名">
      </el-table-column>
      <el-table-column :resizable="false" prop="classFirstDate" label="首次课日期">
      </el-table-column>
      <el-table-column :resizable="false" prop="teacherName" label="首次课教师">
      </el-table-column>
      <el-table-column :resizable="false" prop="classDate" label="上课时间">
      </el-table-column>
      <el-table-column :resizable="false" label="首次课成功情况">
        <template slot-scope="scope">
          <span v-if="scope.row.success == 1">成功</span>
          <span v-if="scope.row.success == 0">未成功</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" :resizable="false" label="备注">
      </el-table-column>
      <el-table-column header-align="center" label="操作" fixed="right" width="150px">
        <template slot-scope="scope">
          <el-button type="text" @click="edit(scope.row.id)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
      layout="prev, pager, next,sizes, jumper" :total="total">
    </el-pagination>

    <!-- 编辑弹窗 -->
    <el-dialog title="首次课历史记录编辑" :visible.sync="dialogFormVisible">
      <el-form label-width="150px">
        <el-form-item label="学生姓名:">
          <el-input autocomplete="off" v-model="editObj.studentName" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="首次课日期:">
          <el-input autocomplete="off" v-model="editObj.classFirstDate" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="首次课教师:">
          <el-input autocomplete="off" v-model="editObj.teacherName" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="上课时间:">
          <el-input autocomplete="off" v-model="editObj.classDate" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="首次课成功情况:" style="width: 100%; text-align: left;">
          <el-radio disabled v-model="editObj.success" label="1">成功</el-radio>
          <el-radio disabled v-model="editObj.success" label="0">未成功</el-radio>
        </el-form-item>
        <el-form-item label="备注:" style="width: 100%;">
          <el-input v-model="editObj.remark" type="textarea" :rows="2" placeholder="请输入内容">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">保 存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";
export default {
  data () {
    return {
      childId: null,
      text: '',
      studentName: '',
      classFirstDate: "",
      success: '',
      classDate: "",
      options: [{
        value: '1',
        label: '成功'
      }, {
        value: '0',
        label: '失败'
      }],
      total: 0,
      requestParameters: {
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },
      dialogFormVisible: false,//编辑弹窗
      id: '',
      editObj: {
        studentName: '',
        classFirstDate: "",
        teacherName: "",
        classDate: "",
        success: "",
        remark: ""
      },
      dataList: [
      ]
    }
  },
  mounted () {

  },
  created () {
    this.id = this.$route.params.id
    this.teacherId = this.$route.params.teacherId
    this.childId = this.$route.params.childId
    this.getList()
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true;  //我理解的是 to 是发送  from 是接收
    next();
    
    // 此处也可以加判断 
    if (to.name === "FirstClassHistory") {
      from.meta.keepAlive = true;
   } 
    next();
  },
  methods: {
    //搜索按钮
    search () {
      if (this.classDate.length > 0) {
        const startTime = this.classDate[0];
        const endTime = this.classDate[1];
        var time = startTime + "-" + endTime;
      } else {
        this.classDate = ''
      }

      let data = {
        classDate: time,
        studentName: this.studentName,
        classFirstDate: this.classFirstDate,
        success: this.success,
        id: this.id,
        teacherId: this.teacherId
      }
      axios
        .post(`${apiBaseUrl}/courseStatistic/getTeacherFirstList`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          if (response.data.code == 200) {
            this.total = response.data.data.total
            this.dataList = response.data.data.records
            this.$message.success(response.data.message)
          }

        })
        .catch(error => {
          console.error(error);
        });
    },
    //清除按钮
    clean () {
      this.studentName = '',
        this.classFirstDate = "",
        this.success = '',
        this.classDate = ''
      this.getList()
    },
    // 获取表格数据
    getList () {
      if (this.$route.params.id !== "null") {
        this.text = '首次课历史记录'
        let data = {
          id: this.id,
          teacherId: this.teacherId,
          pageNum: this.requestParameters.pageNum,
          pageSize: this.requestParameters.pageSize
        }
        axios
          .post(`${apiBaseUrl}/courseStatistic/getTeacherFirstList`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
          .then(response => {
            this.total = response.data.data.total
            this.dataList = response.data.data.records
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        this.text = '月初首次课历史记录'
        let data = {
          id: this.childId,
          teacherId: this.teacherId,
          pageNum: this.requestParameters.pageNum,
          pageSize: this.requestParameters.pageSize
        }
        axios
          .post(`${apiBaseUrl}/courseStatistic/getTeacherFirstListMonth`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
          .then(response => {
            this.total = response.data.data.total
            this.dataList = response.data.data.records
          })
          .catch(error => {
            console.error(error);
          });
      }
    },
    //关闭按钮
    goBack () {
      history.go(-1);
    },
    handleSizeChange (pageSize) {
      this.requestParameters.pageSize = pageSize;
      if (this.requestParameters.page === 1) {
      }
      this.getList(this.requestParameters);
    },
    // 进入某一页
    handleCurrentChange (newPage) {
      this.requestParameters.pageNum = newPage;
      this.getList();
    },
    //编辑

    edit (id) {
      if (this.$route.params.id !== "null") {
        this.dialogFormVisible = true
        axios
          .get(`${apiBaseUrl}/courseStatistic/getFirstDetail?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then(response => {
            // console.log(response);
            if (response.data.code == 200) {
              this.editObj = response.data.data
              this.editObj.success = response.data.data.success + ""
            }
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        this.dialogFormVisible = true
        axios
          .get(`${apiBaseUrl}/courseStatistic/getFirstDetailMonth?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then(response => {
            // console.log(response);
            if (response.data.code == 200) {
              this.editObj = response.data.data
              this.editObj.success = response.data.data.success + ""
            }
          })
          .catch(error => {
            console.error(error);
          });
      }

    },
    save () {
      if (this.$route.params.id !== "null") {
        axios
          .post(`${apiBaseUrl}/courseStatistic/updateFirst`, this.editObj,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
          .then(response => {
            if (response.data.code == 200) {
              this.$message.success("修改成功")
            } else {
              this.$message.error("修改失败")
            }
          })
          .catch(error => {
            console.error(error);
          });
        this.getList()
        this.dialogFormVisible = false
      } else {
        axios
          .post(`${apiBaseUrl}/courseStatistic/updateFirstMonth`, this.editObj,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
          .then(response => {
            if (response.data.code == 200) {
              this.$message.success("修改成功")
            } else {
              this.$message.error("修改失败")
            }
          })
          .catch(error => {
            console.error(error);
          });
        this.getList()
        this.dialogFormVisible = false
      }

    }
  }
}
</script>

<style scoped>
.select {
  display: flex;
  flex-wrap: wrap;
}

.el-icon-circle-close {
  position: absolute;
  right: 10px;
  top: 65px;
  font-size: 24px;
}

@media screen and (max-width: 750px) {
  .firstClassHistory {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.firstClassHistory {
    width: 70% !important;
  }

  .firstClassHistory>>>.el-dialog {
    width: 100% !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/manager/components/FirstClassHistory.vue